function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import * as Yup from "yup";
import "./ScheduledReports.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Dropdown from "react-bootstrap/Dropdown";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { Field, Form as FormikForm, Formik } from "formik";
import { ADD_REPORT_SCHEDULE_MUTATION, LIST_REPORT_SCHEDULES_QUERY, DELETE_REPORT_SCHEDULE, REPORT_ORGANISATION_USER_DETAILS_QUERY } from "./query";
import { useMutation, useQuery } from "@apollo/client";
import { UserContext, FilterContext, SearchContext } from "../index";
import Loader from "./../Loader/Loader";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";
import moment from "moment-timezone";
import Alert from "react-bootstrap/Alert";
import { toast } from "react-toastify";
import { decodeHtmlEntities, encodeHtmlEntities } from "../utils";
import { MdInfoOutline } from "react-icons/md";
import TimePicker from "rc-time-picker";
var ReportsSchema = Yup.object().shape({
  //reportName: Yup.string().required("Required"),
  frequency: Yup.string().required("Required"),
  reportOf: Yup.array().of(Yup.string()).min(1, "Required atleast 1 contents").required("Required atleast 1 contents"),
  reportTo: Yup.array().of(Yup.string()).min(1, "Required atleast 1 option").required("Required atleast 1 option"),
  reportType: Yup.string().required("*Required"),
  sendEmailAt: Yup.string().required("*Required")
  // workedLateAbsentReportType: Yup.string().required("*Required"),
});
function validateReportOf(value) {
  var error;
  if (!value) {
    error = "Required";
  } else if (value.length < 1) {
    error = "Required atleast 1 option";
  }
  return error;
}
var ScheduledReports = function ScheduledReports(props) {
  var _reportSchedulesByFre;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    reportDetails = _React$useState2[0],
    setReportDetails = _React$useState2[1];
  //const [reportSearch, setReportSearch] = React.useState("");

  var Redirect = props.redirect;
  var handleClose = function handleClose() {
    return setReportDetails(null);
  };
  var handleShow = function handleShow(report) {
    setReportDetails(report);
  };
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationStatus = _React$useContext2.organisationStatus;
  var _React$useContext3 = React.useContext(SearchContext),
    reportSearch = _React$useContext3.search;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var loadPage = role === "Admin" || role === "Head" || role === null;
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  var _useQuery = useQuery(LIST_REPORT_SCHEDULES_QUERY, {
      variables: {
        organisationId: organisationId,
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !loadPage
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    reportListLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);

  // const {
  //   data: teamsData,
  //   error: teamsError,
  //   loading: teamsLoading,
  // } = useQuery(ORGANISATION_TEAMS_QUERY, {
  //   variables: {
  //     organisationId,
  //   },
  // });

  var _useQuery2 = useQuery(REPORT_ORGANISATION_USER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId,
        userRole: role
      }
    }),
    reportUserData = _useQuery2.data,
    reportUserError = _useQuery2.error,
    reportUserLoading = _useQuery2.loading;
  var _useMutation = useMutation(DELETE_REPORT_SCHEDULE),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteReportSchedule = _useMutation2[0],
    deleting = _useMutation2[1].loading;
  var _onDelete = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reportId) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return deleteReportSchedule({
              variables: {
                organisationId: organisationId,
                reportId: reportId
              },
              update: function update(cache, _ref2) {
                var isDeleted = _ref2.data.deleteReportSchedule;
                if (!isDeleted) return;
                var _cache$readQuery = cache.readQuery({
                    query: LIST_REPORT_SCHEDULES_QUERY,
                    variables: {
                      organisationId: organisationId,
                      timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                    }
                  }),
                  existingReportSchedules = _cache$readQuery.listReportSchedules;
                var updatedReportSchedule = _objectSpread(_objectSpread({}, existingReportSchedules), {}, {
                  reportSchedulesByFrequency: existingReportSchedules.reportSchedulesByFrequency.map(function (r) {
                    return _objectSpread(_objectSpread({}, r), {}, {
                      reports: r.reports.filter(function (rp) {
                        return rp.reportId !== reportId;
                      })
                    });
                  })
                });
                cache.writeQuery({
                  query: LIST_REPORT_SCHEDULES_QUERY,
                  variables: {
                    organisationId: organisationId,
                    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                  },
                  data: {
                    listReportSchedules: updatedReportSchedule
                  }
                });
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [reportDetails, organisationId]);

  // console.log("start reportLoading", reportListLoading);

  if (reportListLoading) {
    // console.log("reportLoading if", reportListLoading);

    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!data) {
    return null;
  }
  var listReportSchedules = data === null || data === void 0 ? void 0 : data.listReportSchedules;
  var reportsWithSearch = function reportsWithSearch(reports) {
    if (!reportSearch) {
      return reports;
    }
    return reports.filter(function (r) {
      var _r$reportName;
      return r === null || r === void 0 ? void 0 : (_r$reportName = r.reportName) === null || _r$reportName === void 0 ? void 0 : _r$reportName.toLowerCase().includes(reportSearch.toLowerCase());
    });
  };
  if (!listReportSchedules) {
    return null;
  }
  var reportSchedulesByFrequency = listReportSchedules.reportSchedulesByFrequency;
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var reportCheck = (_reportSchedulesByFre = reportSchedulesByFrequency[0]) === null || _reportSchedulesByFre === void 0 ? void 0 : _reportSchedulesByFre.reports.find(function (u) {
    return u.workedLateAbsentReportType == "late-clock-in-report" || u.workedLateAbsentReportType == "absent-report";
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-toolbar"
  }, /*#__PURE__*/React.createElement("div", null, isDemoOrLiveSite === "demo" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't add report in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "font-weight-bold disable-button"
  }, "Create New Report")) : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to create new report.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "font-weight-bold"
  }, "Create New Report")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "font-weight-bold",
    onClick: function onClick() {
      return handleShow({});
    }
  }, "Create New Report"))), (!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) && reportCheck !== undefined ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
    key: "api-limit-waring",
    variant: "danger",
    className: "api-tokens-list-card-toolbar-alert-text-new"
  }, "You need to set the expected clock in time to receive late clock-in and absence email report", " ", /*#__PURE__*/React.createElement("span", null, "(", /*#__PURE__*/React.createElement("a", {
    className: "scheduled-type-err-list",
    href: "https://workfolio.tawk.help/article/how-to-find-late-login-employees",
    target: "_blank"
  }, "Here is the help link"), ")."))) : null, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-data"
  }, reportSchedulesByFrequency.length > 0 ? reportSchedulesByFrequency.map(function (schedule) {
    var _reportsWithSearch;
    var frequency = schedule.frequency,
      reports = schedule.reports;
    return /*#__PURE__*/React.createElement("div", {
      className: "scheduled-reports-card-content"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-primary text-capitalize"
    }, frequency === "daily-at-12-AM" ? "Daily Report" : frequency === "every-sunday" ? "Weekly Report" : "Monthly Report"), /*#__PURE__*/React.createElement(Table, {
      responsive: "sm",
      className: "scheduled-reports-card-table"
    }, /*#__PURE__*/React.createElement("thead", {
      className: "scheduled-reports-card-table-header"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Title"), /*#__PURE__*/React.createElement("th", null, "Type"), /*#__PURE__*/React.createElement("th", null, "Report Of"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
      className: "scheduled-reports-card-table-body"
    }, reportsWithSearch(reports).map(function (report) {
      var reportId = report.reportId,
        reportName = report.reportName,
        reportType = report.reportType,
        reportTo = report.reportsToUser,
        reportOf = report.reportsOfUser,
        createdAt = report.createdAt,
        sendEmailAt = report.sendEmailAt;
      var workedLateAbsentReportType = report.workedLateAbsentReportType;
      workedLateAbsentReportType = workedLateAbsentReportType ? workedLateAbsentReportType : "worked-hours-report";
      var reportOfTemp = reportType == "organisation" ? [organisationId] : reportOf;

      // const dateTemp = moment().format("DD/MM/YYYY");
      // const sendEmailAtValue = moment(dateTemp + " " + sendEmailAt, "DD/MM/YYYY h:mm a");

      return /*#__PURE__*/React.createElement("tr", {
        key: reportId,
        className: "scheduled-reports-card-table-data-details"
      }, /*#__PURE__*/React.createElement("td", {
        className: "scheduled-reports-card-table-data-details-report-name"
      }, decodeHtmlEntities(reportName)), /*#__PURE__*/React.createElement("td", {
        className: "scheduled-reports-card-table-data-details-report-type"
      }, workedLateAbsentReportType == "worked-hours-report" ? "Worked hours" : workedLateAbsentReportType == "late-clock-in-report" ? "Late clock-in" : "Absent"), /*#__PURE__*/React.createElement("td", {
        className: "scheduled-reports-card-table-data-details-report-type"
      }, reportType), /*#__PURE__*/React.createElement("td", {
        className: "scheduled-reports-card-table-data-icon"
      }, /*#__PURE__*/React.createElement(ActionMenuWithButtons, {
        onDelete: function onDelete() {
          return _onDelete(reportId);
        },
        onEdit: function onEdit() {
          return handleShow({
            reportId: reportId,
            reportName: decodeHtmlEntities(reportName),
            frequency: frequency,
            reportType: reportType,
            reportTo: reportTo,
            reportOf: reportOfTemp,
            workedLateAbsentReportType: workedLateAbsentReportType,
            sendEmailAt: sendEmailAt ? sendEmailAt : "12:00 AM"
          });
        },
        deleteProps: {
          title: "Delete report",
          buttonText: "Delete",
          message: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
            className: "font-weight-bold mb-2"
          }, "Are you sure to delete this report?"), /*#__PURE__*/React.createElement("p", {
            className: "text-secondary"
          }, "However you will be able to create a new report like this again anytime."))
        }
      })));
    }), !((_reportsWithSearch = reportsWithSearch(reports)) !== null && _reportsWithSearch !== void 0 && _reportsWithSearch.length) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: 4,
      className: "text-muted text-center"
    }, "No reports ".concat(reportSearch ? "found for \"".concat(reportSearch, "\"") : "found"))) : null)));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "report-no-data"
  }, "No report created !!!"))), /*#__PURE__*/React.createElement(ReportModal, {
    reportDetails: reportDetails,
    handleClose: handleClose,
    organisationId: organisationId,
    userId: user.userId,
    reportUserData: reportUserData,
    role: role,
    organisationSettings: organisationSettings
  }));
};
var ReportModal = function ReportModal(props) {
  var _reportUserData$repor, _reportUserData$repor2, _reportUserData$repor3;
  var reportDetails = props.reportDetails,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    userId = props.userId,
    reportUserData = props.reportUserData,
    role = props.role,
    organisationSettings = props.organisationSettings;
  if (reportDetails === null) {
    return null;
  }
  var now = moment().hour(12).minute(0);
  var defaultReportValues = {
    reportName: "",
    frequency: "daily-at-12-AM",
    reportType: "",
    reportOf: [organisationId],
    //reportTo:userId,
    reportTo: [userId],
    workedLateAbsentReportType: "worked-hours-report",
    sendEmailAt: "12:00 AM"
    // sendEmailAt: "",
  };
  var userData = reportUserData === null || reportUserData === void 0 ? void 0 : (_reportUserData$repor = reportUserData.reportOrganisationUserDetails) === null || _reportUserData$repor === void 0 ? void 0 : _reportUserData$repor.userData;
  var headDetails = reportUserData === null || reportUserData === void 0 ? void 0 : (_reportUserData$repor2 = reportUserData.reportOrganisationUserDetails) === null || _reportUserData$repor2 === void 0 ? void 0 : _reportUserData$repor2.headDetails;

  // REPORTS TO EMPLOYEE OPTIIONS
  var reportToEmployeeOptions = [{
    value: "report_of_selected_employee",
    label: "Send report to corresponding employees"
  }, {
    value: userId,
    label: "Send report to me"
  }];

  // REPORTS OF TEAM OPTIIONS
  var reportOfTeamOptions = [];
  if ((reportUserData === null || reportUserData === void 0 ? void 0 : (_reportUserData$repor3 = reportUserData.reportOrganisationUserDetails) === null || _reportUserData$repor3 === void 0 ? void 0 : _reportUserData$repor3.organisationTeamData.length) > 1) {
    var _reportUserData$repor4;
    reportOfTeamOptions = [{
      label: "All Teams",
      value: "all teams"
    }];
    Array.prototype.push.apply(reportOfTeamOptions, reportUserData === null || reportUserData === void 0 ? void 0 : (_reportUserData$repor4 = reportUserData.reportOrganisationUserDetails) === null || _reportUserData$repor4 === void 0 ? void 0 : _reportUserData$repor4.organisationTeamData);
  } else {
    var _reportUserData$repor5;
    reportOfTeamOptions = reportUserData === null || reportUserData === void 0 ? void 0 : (_reportUserData$repor5 = reportUserData.reportOrganisationUserDetails) === null || _reportUserData$repor5 === void 0 ? void 0 : _reportUserData$repor5.organisationTeamData;
  }

  // REPORTS TO TEAM OPTIIONS
  // let reportToTeamOptions = [{ label: "Send report to me", value: userId }];

  // REPORTS TO ADMIN OPTIIONS
  // const reportToAdminOptions = reportUserData?.reportOrganisationUserDetails?.adminDetails;

  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    reportTypeErr = _React$useState4[0],
    setReportTypeErr = _React$useState4[1];
  var _useMutation3 = useMutation(ADD_REPORT_SCHEDULE_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addReportSchedule = _useMutation4[0],
    reportLoading = _useMutation4[1].loading;
  function handleSubmit(_x2, _x3) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, _ref3) {
      var setFieldError, frequency, reportType, reportOf, reportTo, workedLateAbsentReportType, sendEmailAt, reportName, errorMessage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setFieldError = _ref3.setFieldError;
            if (!reportLoading) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            frequency = values.frequency, reportType = values.reportType, reportOf = values.reportOf, reportTo = values.reportTo, workedLateAbsentReportType = values.workedLateAbsentReportType, sendEmailAt = values.sendEmailAt;
            reportName = values.reportName; //const t = (reportTo ? reportTo:userId )
            if (!((!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) && workedLateAbsentReportType == "late-clock-in-report" || (!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) && workedLateAbsentReportType == "absent-report")) {
              _context2.next = 8;
              break;
            }
            setReportTypeErr(true);
            return _context2.abrupt("return");
          case 8:
            reportName = reportName || "Untitled Report";

            //  let sendEmailAtTimeFormat = sendEmailAt ? moment(sendEmailAt).format("HH:mm a") : null;
            _context2.prev = 9;
            _context2.next = 12;
            return addReportSchedule({
              variables: {
                reportName: encodeHtmlEntities(reportName),
                frequency: frequency,
                reportType: reportType,
                reportOf: reportType === "employee" ? "personal everyone" : reportOf,
                reportTo: reportType === "employee" ? "personal everyone" : reportTo,
                // userId,
                organisationId: organisationId,
                reportId: reportDetails === null || reportDetails === void 0 ? void 0 : reportDetails.reportId,
                workedLateAbsentReportType: workedLateAbsentReportType,
                sendEmailAt: sendEmailAt,
                // sendEmailAt: null,
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              },
              update: function update(cache, _ref10) {
                var newReport = _ref10.data.addReportSchedule;
                var _cache$readQuery2 = cache.readQuery({
                    query: LIST_REPORT_SCHEDULES_QUERY,
                    variables: {
                      organisationId: organisationId,
                      timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                    }
                  }),
                  existingReportSchedules = _cache$readQuery2.listReportSchedules;
                var found = false;
                var newReports = existingReportSchedules.reportSchedulesByFrequency.map(function (r) {
                  var newReportList = _toConsumableArray(r.reports);

                  // if its and edit
                  if (reportDetails !== null && reportDetails !== void 0 && reportDetails.reportId) {
                    newReportList = newReportList.filter(function (rp) {
                      return rp.reportId !== (reportDetails === null || reportDetails === void 0 ? void 0 : reportDetails.reportId);
                    });
                  }
                  if (r.frequency === newReport.frequency) {
                    found = true;
                    newReportList = [].concat(_toConsumableArray(newReportList), [newReport]);
                  }
                  return r;
                });
                if (!found) {
                  newReports.push({
                    frequency: newReport.frequency,
                    reports: [newReport],
                    __typename: "ReportSchedulesByFrequency"
                  });
                }
                cache.writeQuery({
                  query: LIST_REPORT_SCHEDULES_QUERY,
                  variables: {
                    organisationId: organisationId,
                    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                  },
                  data: {
                    listReportSchedules: _objectSpread(_objectSpread({}, existingReportSchedules), {}, {
                      reportSchedulesByFrequency: newReports
                    })
                  }
                });
              }
            });
          case 12:
            handleClose();
            toast.success(isNewReport ? "Report added successfully!" : "Report updated successfully!");
            _context2.next = 21;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](9);
            console.log({
              error: _context2.t0
            });
            errorMessage = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || "";
            if (errorMessage.includes("You've reached the maximum")) {
              setFieldError("formError", errorMessage.replace("GraphQL error: ", ""));
            } else {
              setFieldError("formError", "Something went wrong! Please try again later");
            }
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9, 16]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  var isNewReport = React.useMemo(function () {
    return reportDetails != null && Object.keys(reportDetails).length < 1;
  });
  var reportOfOnChange = function reportOfOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray && selectedArray.some(function (el) {
        return el.value === "everyone";
      })) {
        setFieldValue("reportOf", ["everyone"]);
      } else if (selectedArray && selectedArray.some(function (el) {
        return el.value === "all teams";
      })) {
        setFieldValue("reportOf", ["all teams"]);
      } else if (selectedArray && !selectedArray.some(function (el) {
        return el.value === "everyone" || el.value === "all teams";
      })) {
        setFieldValue("reportOf", selectedArray.map(function (item) {
          return item.value;
        }));
      } else {
        setFieldValue("reportOf", []);
      }
    };
  };

  // const reportToOnChange = (setFieldValue) => (selectedArray) => {
  //   if (selectedArray) {
  //     setFieldValue(
  //       "reportTo",
  //       selectedArray.map((item) => item.value)
  //     );
  //   } else {
  //     setFieldValue("reportTo", []);
  //   }
  // };

  if (!Boolean(reportDetails)) return null;

  //console.log("userData",userData);
  var reportTypeList = [{
    label: "Worked Hours Report",
    value: "worked-hours-report"
  }, {
    label: "Late Clock-In Report",
    value: "late-clock-in-report"
  }, {
    label: "Absent Report",
    value: "absent-report"
  }];
  var formats = "h:mm a";
  function disabledClockInReminderMinutes() {
    var length = 60;
    var includeOptions = [0, 15, 30, 45];
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (includeOptions.indexOf(value) < 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  function disabledHours() {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  }
  var mailSentList = [];

  // // // 3. From 12:15 AM to 11:45 AM
  // for (let h = 0; h <= 11; h++) {
  //   for (let m = 0; m < 60; m += 15) {
  //     // skip 12:00 AM because it is added as “Day Start”
  //     if (h === 0 && m === 0) continue;

  //     const hour12 = h % 12 === 0 ? 12 : h % 12;
  //     const minute = m.toString().padStart(2, "0");
  //     const label = `${hour12}:${minute} am`;
  //     const value = label;

  //     mailSentList.push({ label, value });
  //   }
  // }

  for (var h = 12; h <= 24; h++) {
    // 20 = 8PM, 24 = midnight
    for (var m = 0; m < 60; m += 30) {
      // Stop at 12:00 AM only
      if (h === 24 && m > 0) break;
      var label = void 0,
        value = void 0;
      if (h === 24) {
        // Midnight
        label = "Midnight 12:00 AM";
        value = "12:00 AM";
      } else if (h === 12 && m <= 0) {
        // Midnight
        label = "12 PM Noon";
        value = "12:00 PM";
      } else {
        var hour24 = h === 24 ? 0 : h;
        var hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
        var minute = m.toString().padStart(2, "0");
        var ampm = hour24 < 12 ? "AM" : "PM";
        label = "".concat(hour12, ":").concat(minute, " ").concat(ampm);
        value = label;
      }
      mailSentList.push({
        label: label,
        value: value
      });
    }
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "scheduled-reports-new-report-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "scheduled-reports-new-report-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "scheduled-reports-new-report-modal-title"
  }, "New Schedule Report")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "scheduled-reports-new-report-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: isNewReport ? defaultReportValues : reportDetails,
    validationSchema: ReportsSchema,
    onSubmit: handleSubmit
  }, function (_ref4) {
    var isSubmitting = _ref4.isSubmitting,
      errors = _ref4.errors,
      touched = _ref4.touched,
      values = _ref4.values,
      setFieldValue = _ref4.setFieldValue,
      setFieldTouched = _ref4.setFieldTouched;
    var reportOfOptions = values.reportType === "employee" ? userData : values.reportType === "team" ? reportOfTeamOptions : [];

    // const reminderTimeError = errorMessage(errors, touched, "sendEmailAt");

    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mt-2 mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "workedLateAbsentReportType"
      // validate={validateReportOf}
    }, function (_ref5) {
      var field = _ref5.field,
        form = _ref5.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Report Type"), errors.workedLateAbsentReportType && touched.workedLateAbsentReportType ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, errors.workedLateAbsentReportType) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: reportTypeList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(e) {
          setFieldValue("workedLateAbsentReportType", e.value);
          if ((!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) && (e.value == "late-clock-in-report" || e.value == "absent-report")) {
            setReportTypeErr(true);
          } else {
            setReportTypeErr(false);
          }
          if (e.value != "worked-hours-report" && values.frequency != "daily-at-12-AM") {
            setFieldValue("frequency", "daily-at-12-AM");
          }
        },
        options: reportTypeList,
        className: "email-reports-value-text"
      })), reportTypeErr && values.workedLateAbsentReportType == "late-clock-in-report" || reportTypeErr && values.workedLateAbsentReportType == "absent-report" ? /*#__PURE__*/React.createElement("div", {
        className: "scheduled-typr-err"
      }, "Set the expected clock-in time to create the", " ", values.workedLateAbsentReportType == "late-clock-in-report" ? "late clock-in" : "absent", " ", "email report", /*#__PURE__*/React.createElement("span", {
        className: "scheduled-type-err-span"
      }, " ", "(", /*#__PURE__*/React.createElement("a", {
        className: "scheduled-type-err-a",
        href: "https://workfolio.tawk.help/article/how-to-find-late-login-employees",
        target: "_blank"
      }, "Here is the guide to set the expected clock-in"), ").")) : null);
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Report Title"), errors.reportName && touched.reportName ? /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, errors.reportName) : null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      name: "reportName",
      type: "text",
      placeholder: "Enter the report title",
      isInvalid: errors.reportName && touched.reportName,
      className: "email-reports-value-text"
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "email-reports-checkbox-label"
    }, "Frequency"), errors.frequency && touched.frequency ? /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, errors.frequency) : null, /*#__PURE__*/React.createElement("div", {
      className: "scheduled-reports-new-report-modal-frequency"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Daily"
      // label="Daily at 12AM"
      ,
      value: "daily-at-12-AM",
      name: "frequency",
      id: "frequency-daily",
      className: "scheduled-reports-new-report-modal-radion-button email-reports-value-text"
    }), values.workedLateAbsentReportType == "" || values.workedLateAbsentReportType == null || values.workedLateAbsentReportType == "worked-hours-report" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Every Sunday",
      value: "every-sunday",
      name: "frequency",
      id: "frequency-weekly",
      className: "scheduled-reports-new-report-modal-radion-button email-reports-value-text"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Every month 1st day",
      value: "every-month-1st-day",
      name: "frequency",
      id: "frequency-monthly",
      className: "scheduled-reports-new-report-modal-radion-button email-reports-value-text "
    })) : null))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
      // validate={validateReportOf}
    }, function (_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, " ", "Send Email At (Based on organization's timezone)", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), errors.sendEmailAt && touched.sendEmailAt ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, errors.sendEmailAt) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: mailSentList.find(function (option) {
          return option.value === field.value;
        }) || null,
        onChange: function onChange(e) {
          setFieldValue("sendEmailAt", e.value);
        },
        options: mailSentList,
        className: "email-reports-value-text"
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reportType"
    }, function (_ref7) {
      var field = _ref7.field;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "email-reports-checkbox-label"
      }, "Report Of"), errors.reportType && touched.reportType ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, errors.reportType) : null, /*#__PURE__*/React.createElement("div", {
        className: "scheduled-reports-new-report-modal-frequency"
      }, /*#__PURE__*/React.createElement(Field, {
        as: Form.Check,
        inline: true,
        type: "radio",
        value: "team",
        label: "Team summary",
        name: "reportType",
        id: "reportType-team",
        className: "scheduled-reports-new-report-modal-radion-button email-reports-value-text"
      }), role === "Admin" ? /*#__PURE__*/React.createElement(Field, {
        as: Form.Check,
        inline: true,
        type: "radio",
        value: "organisation",
        label: "Organisation summary",
        name: "reportType",
        id: "reportType-organisation",
        className: "scheduled-reports-new-report-modal-radion-button email-reports-value-text"
      }) : null));
    })), values.reportType === "team" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reportOf",
      validate: validateReportOf
    }, function (_ref8) {
      var field = _ref8.field,
        form = _ref8.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Whose report do you want to be received?"), errors.reportOf && touched.reportOf ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, errors.reportOf) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: reportOfOptions.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: reportOfOnChange(form.setFieldValue),
        options: reportOfOptions,
        isMulti: true,
        className: "email-reports-value-text"
      })));
    })) : null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reportTo"
      // validate={validateReportOf}
    }, function (_ref9) {
      var field = _ref9.field,
        form = _ref9.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Send report to"), errors.reportTo && touched.reportTo ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, errors.reportTo) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userData.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(option) {
          form.setFieldValue(field.name, option == null ? [] : option.map(function (item) {
            return item.value;
          }));
        },
        options: userData,
        isMulti: true,
        className: "email-reports-value-text"
      })));
    })), values.reportType === "employee" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "employee-report-text"
    }, "This report will be sent to all members. It has their own work details like clock-in time, clock-out time, worked hours and few other details.")) : null, isNewReport ? /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "scheduled-reports-new-report-modal-note-message"
    }, "Note: This report is going to be triggered at ".concat(values.sendEmailAt, " "), values.frequency === "daily-at-12-AM" ? "every day" : values.frequency === "every-sunday" ? "every sunday" : "on the 1st day of the month", ".")) : null, /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error"
    }, errors.formError) : null), /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center justify-content-center mx-n1 scheduled-reports-new-report-modal-create-button"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-1"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "schedule-report-modal-button",
      variant: "primary",
      size: "sm",
      type: "submit",
      disabled: isSubmitting || reportLoading || reportTypeErr
    }, isSubmitting || isNewReport ? "Create Report" : reportLoading ? "Creating..." : "Update Report"))))));
  })));
};
export var ActionMenu = function ActionMenu(props) {
  var onEdit = props.onEdit,
    onDelete = props.onDelete,
    _props$Icon = props.Icon,
    Icon = _props$Icon === void 0 ? HiOutlineDotsVertical : _props$Icon,
    deleteProps = props.deleteProps;
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showConfirmation = _React$useState6[0],
    setShowConfirmation = _React$useState6[1];
  var handleClose = function handleClose() {
    return setShowConfirmation(false);
  };
  var handleOpen = function handleOpen() {
    return setShowConfirmation(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "action-menu"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "light",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    menuAlign: "right"
  }, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: onEdit
  }, "Edit"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "text-danger",
    onClick: handleOpen
  }, "Delete"))), /*#__PURE__*/React.createElement(DeleteConfirmation, _extends({
    show: showConfirmation,
    onClose: handleClose,
    onOk: onDelete
  }, deleteProps)));
};
export var ActionMenuWithButtons = function ActionMenuWithButtons(props) {
  var onEdit = props.onEdit,
    onDelete = props.onDelete,
    _props$Icon2 = props.Icon,
    Icon = _props$Icon2 === void 0 ? HiOutlineDotsVertical : _props$Icon2,
    deleteProps = props.deleteProps;
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    showConfirmation = _React$useState8[0],
    setShowConfirmation = _React$useState8[1];
  var handleClose = function handleClose() {
    return setShowConfirmation(false);
  };
  var handleOpen = function handleOpen() {
    return setShowConfirmation(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div",
    onClick: onEdit
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit")), /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div",
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete"))), /*#__PURE__*/React.createElement(DeleteConfirmation, _extends({
    show: showConfirmation,
    onClose: handleClose,
    onOk: onDelete
  }, deleteProps)));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    onClose = props.onClose,
    title = props.title,
    onOk = props.onOk,
    message = props.message,
    buttonText = props.buttonText;
  var onAgree = function onAgree() {
    onOk();
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, title || "Alert")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, message), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: onAgree
  }, buttonText)));
};
export default ScheduledReports;